import { useCallback, useMemo, useState } from 'react';

import { getString } from '../../../../strings';
import { StyledText } from '../../../atoms/Text/StyledText';
import { StyledButton } from '../../../atoms/Button/StyledButton';
import { BigLoader, StyledBigLoader } from '../../../atoms/Loader/StyledBigLoader';
import { removeAvatar } from '../../../../logic/requests/users';
import PaymentsPopup from '../../../organisms/Payments/PaymentsPopup';
import { useQueryClient } from '@tanstack/react-query';

const RemoveAvatarPopup = ({ eventId, closePopup, player }) => {
    const [avatarRemoved, setAvatarRemoved] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const queryClient = useQueryClient();

    const onSubmit = useCallback(() => {
        setIsLoading(true);
        removeAvatar(player.id)
            .then((res) => {
                setIsLoading(false);
                queryClient.invalidateQueries(['eventPlayers', eventId]);
                setAvatarRemoved(true);
            })
            .catch(() => {
                setIsLoading(false);
            });
    }, [eventId, player.id, queryClient]);

    const renderContent = useMemo(
        () =>
            avatarRemoved ? (
                <div>
                    <StyledText
                        hasdeclaredfontsize="18px"
                        hasdeclaredpadding={'50px 20px 20px 20px'}
                        hasdeclaredlineheight="1.4em"
                        hasdeclaredtextalign="center"
                    >
                        {getString('remove_avatar_button_success_text')}
                    </StyledText>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredbgcolor="#6786BE"
                            hasdeclaredpadding="0 28px"
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredborderradius="25px"
                            hasdeclaredfontweight="700"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredfontsize="18px"
                            hasdeclaredtexttransform="uppercase"
                            hasdeclaredheight="50px"
                            hasdeclaredmargin="20px auto 0"
                            onClick={closePopup}
                        >
                            {getString('all_trainer_pay_popup_zamknij')}
                        </StyledButton>
                    </div>
                </div>
            ) : isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <BigLoader />
                </div>
            ) : (
                <>
                    <div>
                        <StyledText
                            hasdeclaredfontsize="18px"
                            hasdeclaredpadding={'50px 20px 0px 20px'}
                            hasdeclaredlineheight="1.4em"
                            hasdeclaredtextalign="center"
                        >
                            {getString('remove_avatar_popup_text1')}
                        </StyledText>
                        <StyledText
                            hasdeclaredfontsize="18px"
                            hasdeclaredpadding={'0px 20px 0px 20px'}
                            hasdeclaredlineheight="1.4em"
                            hasdeclaredtextalign="center"
                            hasdeclaredfontweight="700"
                        >
                            {`${player.firstname} ${player.lastname}?`}
                        </StyledText>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            onClick={onSubmit}
                        >
                            {getString('remove_avatar_button_confirm_text')}
                        </StyledButton>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#ee745c"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            onClick={closePopup}
                        >
                            {getString('userPanel_userPanelTournament_payment_reminder_cancel')}
                        </StyledButton>
                    </div>
                </>
            ),
        [avatarRemoved, isLoading, closePopup, onSubmit, player.firstname, player.lastname]
    );

    return <PaymentsPopup>{renderContent}</PaymentsPopup>;
};

export default RemoveAvatarPopup;
